export default "__VITE_ASSET__BFhdLSjr__"